import { debugErrorMap } from 'firebase/auth';

import { getFirestore, collection, query, where, doc, getDocs, onSnapshot, getDoc, orderBy, limit, startAfter, endBefore, limitToLast, arrayUnion } from 'firebase/firestore';
import { deleteDoc, updateDoc, setDoc } from '../api/FirestoreInterceptor';
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  getBytes,
} from 'firebase/storage';

//FIRESTORE
import { db } from '../config-firebase/firebase';

/**
 * Escuta em tempo real apenas os pedidos que já têm nota emitida (nfceIssued: true) 
 * mas que ainda não foram impressos (nfcePrinted: false).
 * Usado pelo FiscalObserver para otimizar performance e não ler a coleção inteira.
 */
export function fetchPendingPrints(onData) {
  const q = query(
    collection(db, 'requests'),
    where('nfceIssued', '==', true),
    where('nfcePrinted', '==', false) // Only get what needs printing
  );
  return onSnapshot(q, (snapshot) => {
    const data = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    onData(data);
  });
}

/**
 * Atualiza ou cria uma chave em um documento de uma coleção específica.
 * Após a atualização, recarrega a página para refletir as mudanças.
 *
 * @param {string} collectionName - Nome da coleção.
 * @param {string} docId - ID do documento a ser atualizado.
 * @param {string} key - Chave a ser atualizada/criada.
 * @param {*} value - Valor a ser atribuído à chave.
 * @returns {Promise<string>} Mensagem de sucesso ou erro detalhado.
 */
export async function updateOrCreateKeyInDocument(
  collectionName,
  docId,
  key,
  value
) {
  try {
    const docRef = doc(db, collectionName, docId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      return `Erro: Documento com id "${docId}" não encontrado na coleção "${collectionName}".`;
    }

    const data = docSnap.data();
    const updateData = {};
    updateData[key] = value;

    await updateDoc(docRef, updateData);

    // Recarrega a página após a atualização
    if (typeof window !== 'undefined' && window.location) {
      window.location.reload();
    }

    if (Object.prototype.hasOwnProperty.call(data, key)) {
      return `Chave "${key}" atualizada com sucesso no objeto ${docId} da coleção "${collectionName}".`;
    } else {
      return `Chave "${key}" criada e atribuída com sucesso no objeto ${docId} da coleção "${collectionName}".`;
    }
  } catch (error) {
    if (error.code === 'not-found') {
      return `Erro: Coleção "${collectionName}" não encontrada.`;
    }
    return `Erro ao atualizar/criar chave: ${error.message}`;
  }
}

export async function getStockByProductName(productName) {
  try {
    const stockCollection = collection(db, 'stock');
    const q = query(stockCollection, where('product', '==', productName));
    //“Quero todos os documentos da coleção stock onde o campo product é igual ao productName informado.”
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      return querySnapshot.docs[0].data(); // retornando o primeiro match
    } else {
      return null;
    }
  } catch (error) {
    console.error('Erro ao buscar o stock:', error);
    return null;
  }
}

//Bringing by query data
export async function fetchingByQuery(reference, collectionName) {
  try {
    const Ref = collection(db, collectionName); // referencia a coleção "sideDishes"

    // Filtra os documentos pelo campo "sideDishes" igual ao nome recebido
    const q = query(Ref, where(collectionName, '==', reference));

    const querySnapshot = await getDocs(q); // Executa a consulta

    // Verifica se encontrou algum documento
    if (!querySnapshot.empty) {
      const doc = querySnapshot.docs[0]; // Pega o primeiro documento encontrado
      const costPriceObj = doc.data(); // Obtém os dados do documento
      // Retorna o objeto com os dados de custo e preço
      return costPriceObj;
    } else {
      console.log('Acompanhamento não encontrado');
      return null;
    }
  } catch (error) {
    console.error('Erro ao buscar o acompanhamento:', error);
    return null;
  }
}

//Bringing collecton whenever ther was any change in data
export function fetchInDataChanges(collectionName, onData) {
  const requestCollection = collection(db, collectionName);

  const unsubscribe = onSnapshot(requestCollection, (snapshot) => {
    const data = snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    onData(data);
  });
  return unsubscribe;
}

//Delete item in collection
export async function deleteData(coolectionName, id) {
  try {
    const docRef = doc(db, coolectionName, id);
    await deleteDoc(docRef);
  } catch (error) {
    console.log(error);
  }
}

//Remove item in the "request" array list
export async function deleteRequestItem(userId, itemId) {
  const userRef = doc(db, 'user', userId);

  try {
    const userDoc = await getDoc(userRef);

    if (userDoc.exists()) {
      const userData = userDoc.data();
      console.log('Dados do usuário:', userData);

      if (userData.request && Array.isArray(userData.request)) {
        const updatedRequest = userData.request.filter(
          (_, index) => index != itemId
        );

        await updateDoc(userRef, {
          request: updatedRequest,
        });
      }

      console.log('Item removed successfully.');
    } else {
      console.log('User not found.');
    }
  } catch (error) {
    console.log('Error removing item: ', error);
  }
}

//Bringing collection and tranform in array
export async function getBtnData(collectionName) {
  const db = getFirestore();
  const docRef = collection(db, collectionName);
  try {
    const docSnap = await getDocs(docRef);
    let array = [];
    docSnap.forEach((doc) => {
      array.push({ ...doc.data(), id: doc.id });
    });
    return array;
  } catch (error) {
    throw error;
  }
}

//The name is clear just one item
export async function getOneItemColleciton(collectionName, itemId) {
  const db = getFirestore();
  const docRef = doc(db, collectionName, itemId);

  try {
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { ...docSnap.data(), id: docSnap.id };
    } else {
      throw new Error('No document found with the given ID');
    }
  } catch (error) {
    throw error;
  }
}

//Bring Categories
export async function fetchCategories(item) {
  const categories = await getBtnData(item);
  return categories.map((item) => item.parent);
}

export async function fetchCategoriesItem(collectionName) {
  const parents = await fetchCategories(collectionName); // All parents used
  const categories = await getBtnData(collectionName); //Whole objects array from firevase

  let usedCategories = new Set(categories.map((item) => item.category)); //Changing categories in object and  to set to remove duplicates
  const noUsedParentsItems = parents.filter(
    (item) => !usedCategories.has(item)
  ); //Filtering parents that are not in usedCategories

  return noUsedParentsItems;
}

// export async function fetchCategoriesButton(collectionName){
//     const categoriesItem = await getBtnData(collectionName)
//     const  filteredCategoriesItem = new Set(categoriesItem.map((item)=> item.category))
//     let btnCategories = await getBtnData("button")
//     btnCategories = btnCategories.map((item)=> item.category)
//     return [...new Set(btnCategories.filter((item) => !filteredCategoriesItem.has(item)))];

// }
export async function fetchCategoriesButton(collectionName) {
  const dishesCategories = new Set(
    (await getBtnData(collectionName)).map((item) => item.category) //Categoria de todos os pratos publicados
  );

  const btnCategories = (await getBtnData('button')).map((item) => item.parent); //Todas as categorias já criadas
  // Parent pode ser o pai de um botão ou de um prato se ele tiver um filho
  // botão ele pode ter neto, se o filho dele for um prato ele não pode ter neto, porque
  //prato não pode ter filho
  return [
    ...new Set(btnCategories.filter((item) => !dishesCategories.has(item))),
  ];
}

export const updateItemsSideDishes = async () => {
  try {
    // Pega todos os acompanhamentos da coleção 'sideDishes'
    const allSideDishes = await getBtnData('sideDishes');

    // Pega todos os itens da coleção 'item'
    const allItems = await getBtnData('item');

    // Percorre cada item da coleção 'item'
    for (const item of allItems) {
      const updatedSideDishes = [];

      // Percorre o array sideDishesElementList de cada item
      for (const sideDishElement of item.sideDishesElementList) {
        // Encontra o acompanhamento correspondente na coleção 'sideDishes'
        const matchedSideDish = allSideDishes.find(
          (sideDish) => sideDish.id === sideDishElement.id
        );

        // Se houver um acompanhamento correspondente, verifica se houve alteração
        if (matchedSideDish) {
          const updatedElement = {
            ...sideDishElement,
            price: matchedSideDish.price, // Atualiza o preço
            sideDishes: matchedSideDish.sideDishes, // Atualiza o nome
            unavailableRawMaterial: matchedSideDish.unavailableRawMaterial || false, // Atualiza disponibilidade
          };
          updatedSideDishes.push(updatedElement);
        } else {
          // Caso não encontre o acompanhamento, mantém o original
          updatedSideDishes.push(sideDishElement);
        }
      }

      // Verifica se houve mudanças no sideDishesElementList
      const itemRef = doc(db, 'item', item.id);

      if (
        JSON.stringify(updatedSideDishes) !==
        JSON.stringify(item.sideDishesElementList)
      ) {
        // Se houver mudanças, atualiza o item no Firestore
        await updateDoc(itemRef, {
          sideDishesElementList: updatedSideDishes,
        });
        console.log(`Item atualizado: ${item.title}`);
      }
    }
    console.log('Atualização concluída.');
  } catch (error) {
    console.error('Erro ao atualizar sideDishesElementList: ', error);
  }
};

/**
 * Atualiza um documento dentro de uma coleção específica.
 *
 * @param {string} collectionName - Nome da coleção (ex: 'recipes', 'products')
 * @param {string} docId - ID do documento a ser atualizado
 * @param {object} data - Objeto com os campos que devem ser atualizados
 */
export async function updateCollection(collectionName, docId, data) {
  try {
    const docRef = doc(db, collectionName, docId);
    await updateDoc(docRef, data);
    console.log(
      `Documento ${docId} na coleção "${collectionName}" atualizado com sucesso.`
    );
  } catch (error) {
    console.error(
      `Erro ao atualizar o documento ${docId} na coleção "${collectionName}":`,
      error
    );
    throw error;
  }
}
/**
 * Adiciona um item a uma coleção no Firestore. Se a coleção não existir, ela será criada automaticamente.
 *
 * @param {string} collectionName - Nome da coleção.
 * @param {object} data - Dados do item a ser adicionado.
 * @returns {Promise<string>} - ID do documento criado ou mensagem de erro.
 */
export async function addItemToCollection(collectionName, data) {
  try {
    const dbRef = collection(db, collectionName);
    const docRef = await import('firebase/firestore').then((mod) =>
      mod.addDoc(dbRef, data)
    );
    return docRef.id;
  } catch (error) {
    console.error('Erro ao adicionar item à coleção:', error);
    throw error;
  }
}
/**
 * Substitui completamente um documento pelo objeto fornecido na coleção especificada.
 *
 * @param {string} collectionName - Nome da coleção.
 * @param {string} docId - ID do documento a ser substituído.
 * @param {object} newData - Novo objeto que substituirá o documento existente.
 * @returns {Promise<void>}
 */
export async function replaceDocument(collectionName, docId, newData) {
  try {
    const docRef = doc(db, collectionName, docId);
    await import('firebase/firestore').then((mod) =>
      mod.setDoc(docRef, newData, { merge: false })
    );
    console.log(
      `Documento ${docId} na coleção "${collectionName}" substituído com sucesso.`
    );
  } catch (error) {
    console.error(
      `Erro ao substituir o documento ${docId} na coleção "${collectionName}":`,
      error
    );
    throw error;
  }
}

/**
 * Recupera dados de uma coleção com paginação (Server-Side).
 * 
 * @param {string} collectionName - Nome da coleção (ex: 'requests').
 * @param {string} orderByField - Campo numérico para ordenação (ex: 'countRequest').
 * @param {string} orderDirection - 'asc' ou 'desc'.
 * @param {number} pageSize - Quantidade de itens por página (ex: 40).
 * @param {object} cursorDoc - O documento Firebase de referência para continuar a busca.
 * @param {string} directionType - 'init' (primeira carga), 'next' (próxima página) ou 'prev' (página anterior).
 */
export async function getPaginatedData(
  collectionName,
  orderByField,
  orderDirection,
  pageSize,
  cursorDoc,
  directionType
) {
  const db = getFirestore();
  const colRef = collection(db, collectionName);

  let q = query(colRef, orderBy(orderByField, orderDirection));

  if (directionType === 'init') {
    q = query(q, limit(pageSize));
  } else if (directionType === 'next' && cursorDoc) {
    q = query(q, startAfter(cursorDoc), limit(pageSize));
  } else if (directionType === 'prev' && cursorDoc) {
    q = query(q, endBefore(cursorDoc), limitToLast(pageSize));
  } else {
    // Fallback pra init caso falte o cursor
    q = query(q, limit(pageSize));
  }

  try {
    const querySnapshot = await getDocs(q);

    // Extrai o primeiro e o último documento (snapshots originais, necessários para as referências de startAfter/endBefore)
    const firstVisible = querySnapshot.docs.length > 0 ? querySnapshot.docs[0] : null;
    const lastVisible = querySnapshot.docs.length > 0 ? querySnapshot.docs[querySnapshot.docs.length - 1] : null;

    let array = [];
    querySnapshot.forEach((docSnap) => {
      array.push({ ...docSnap.data(), id: docSnap.id });
    });

    return {
      data: array,
      firstVisible,
      lastVisible,
      empty: querySnapshot.empty
    };
  } catch (error) {
    console.error(`Erro ao buscar página em ${collectionName}:`, error);
    throw error;
  }
}

/**
 * Registra um evento de uso/histórico para um item do estoque em uma coleção separada.
 *
 * @param {string} stockId - ID do item no estoque.
 * @param {object} logEntry - Dados do log (date, inputProduct, cost, etc).
 */
export async function logStockUsage(stockId, logEntry) {
  try {
    const logsRef = collection(db, 'stockUsageLogs');
    await import('firebase/firestore').then((mod) =>
      mod.addDoc(logsRef, {
        stockId,
        timestamp: new Date().toISOString(),
        ...logEntry
      })
    );
  } catch (error) {
    console.error('Erro ao registrar log de estoque:', error);
  }
}

/**
 * Busca o histórico de logs de um item de estoque específico.
 *
 * @param {string} stockId - ID do item no estoque.
 * @param {number} limitCount - Número máximo de logs a retornar.
 */
export async function fetchStockUsageLogs(stockId) {
  try {
    const logsRef = collection(db, 'stockUsageLogs');
    // Busca logs específicos deste stockId (sem orderBy no Firebase para não exigir index composto imediato)
    const q = query(
      logsRef,
      where('stockId', '==', stockId)
    );
    const querySnapshot = await getDocs(q);
    
    let logs = [];
    querySnapshot.forEach((docSnap) => {
      logs.push({ ...docSnap.data(), id: docSnap.id });
    });
    
    // Ordena localmente pela data ou timestamp
    logs.sort((a, b) => {
      const timeA = a.timestamp ? new Date(a.timestamp).getTime() : 0;
      const timeB = b.timestamp ? new Date(b.timestamp).getTime() : 0;
      return timeB - timeA; // Descendente (mais recentes primeiro)
    });

    return logs;
  } catch (error) {
    console.error('Erro ao buscar logs de estoque:', error);
    return [];
  }
}

/**
 * Edita uma entrada de estoque no histórico e ajusta os saldos do item no banco.
 */
export async function updateStockLogEntry(logId, stockId, newVolume, newCost, newPackage) {
  try {
    const { doc, getDoc, updateDoc } = await import('firebase/firestore');
    const { db } = await import('../config-firebase/firebase.js');

    const logRef = doc(db, 'stockUsageLogs', logId);
    const logSnap = await getDoc(logRef);
    if (!logSnap.exists()) return false;

    const oldData = logSnap.data();
    const oldVolume = Number(oldData.inputProduct || oldData.entrada || 0);
    const oldCost = Number(oldData.cost || 0);

    // Buscar volumePerUnit do estoque para converter o volume antigo em quantidade de pacotes caso entryAmount não esteja disponível
    let volPerUnit = 1;
    if (oldData.entryAmount === undefined && stockId) {
      const stockRef = doc(db, 'stock', stockId);
      const stockSnap = await getDoc(stockRef);
      if (stockSnap.exists()) {
        const sData = stockSnap.data();
        volPerUnit = Number(sData.volumePerUnit) > 0 ? Number(sData.volumePerUnit) : 1;
      }
    }
    const oldEntryPackage = oldData.entryAmount !== undefined ? Number(oldData.entryAmount) : (volPerUnit > 0 ? Math.round(oldVolume / volPerUnit) : 1);

    const diffVolume = Number(newVolume) - oldVolume;
    const diffCost = Number(newCost) - oldCost;
    const diffPackage = Number(newPackage) - oldEntryPackage;

    await updateDoc(logRef, {
      inputProduct: Number(newVolume),
      cost: Number(newCost),
      package: Math.max(0, Number(oldData.package || 0) + diffPackage), // atualiza o acumulado de pacotes no log
      totalResourceInvested: Math.max(0, Number(oldData.previousCost || 0) + Number(newCost)),
      ContentsInStock: Math.max(0, Number(oldData.previousVolume || 0) + Number(newVolume)),
      entryVolumePerUnit: Number(newVolume) / Math.max(1, Number(newPackage)),
      entryAmount: Number(newPackage),
    });

    if (stockId) {
      const stockRef = doc(db, 'stock', stockId);
      const stockSnap = await getDoc(stockRef);
      if (stockSnap.exists()) {
        const sData = stockSnap.data();
        let updatedVolume = Math.max(0, Number(sData.totalVolume || 0) + diffVolume);
        let updatedCost = Math.max(0, Number(sData.totalCost || 0) + diffCost);
        let updatedPackage = Math.max(0, Number(sData.amount || 0) + diffPackage);
        let updatedCostPerUnit = updatedVolume > 0 ? Number((updatedCost / updatedVolume).toFixed(2)) : 0;

        const updateData = {
          totalVolume: updatedVolume,
          totalCost: updatedCost,
          amount: updatedPackage,
          CostPerUnit: updatedCostPerUnit,
        };
        if (updatedCostPerUnit > 0) {
          updateData.lastUnitCost = updatedCostPerUnit;
        }

        await updateDoc(stockRef, updateData);
      }
    }
    return true;
  } catch (err) {
    console.error('Erro ao atualizar log de estoque:', err);
    return false;
  }
}

/**
 * Edita um log de descarte de estoque no histórico e ajusta os saldos do item no banco.
 */
export async function updateStockDiscardLogEntry(logId, stockId, newDiscardAmount, newNote) {
  try {
    const { doc, getDoc, updateDoc, collection, query, where, getDocs } = await import('firebase/firestore');
    const { db } = await import('../config-firebase/firebase.js');

    const logRef = doc(db, 'stockUsageLogs', logId);
    const logSnap = await getDoc(logRef);
    if (!logSnap.exists()) return false;

    const oldLogData = logSnap.data();
    const oldDiscardVal = Number(oldLogData.outputProduct || oldLogData.saida || 0);
    const newDiscardVal = Number(newDiscardAmount);

    const baseVolume = Number(oldLogData.previousVolume !== undefined ? oldLogData.previousVolume : 0);
    const baseCost = Number(oldLogData.previousCost !== undefined ? oldLogData.previousCost : 0);

    const unitPrice = baseVolume > 0 ? (baseCost / baseVolume) : 0;
    const newVolumeAfterDiscard = Math.max(0, baseVolume - newDiscardVal);
    const newCostAfterDiscard = Number((newVolumeAfterDiscard * unitPrice).toFixed(2));

    const diffDiscardVolume = newDiscardVal - oldDiscardVal;
    const oldDiscardCost = baseCost - Number(oldLogData.totalResourceInvested || 0);
    const newDiscardCost = baseCost - newCostAfterDiscard;
    const diffDiscardCost = newDiscardCost - oldDiscardCost;

    // 1. Atualizar o documento no stockUsageLogs
    await updateDoc(logRef, {
      outputProduct: newDiscardVal,
      ContentsInStock: newVolumeAfterDiscard,
      totalResourceInvested: newCostAfterDiscard,
      noteReasonsEditingProduct: newNote,
    });

    // 2. Atualizar a matéria-prima na coleção stock
    const targetStockId = stockId || oldLogData.stockId;
    if (targetStockId) {
      const stockRef = doc(db, 'stock', targetStockId);
      const stockSnap = await getDoc(stockRef);
      if (stockSnap.exists()) {
        const sData = stockSnap.data();
        let updatedVolume = Math.max(0, Number(sData.totalVolume || 0) - diffDiscardVolume);
        let updatedCost = Math.max(0, Number(sData.totalCost || 0) - diffDiscardCost);
        let updatedPackage = Number(sData.volumePerUnit) > 0 
          ? Number((updatedVolume / Number(sData.volumePerUnit)).toFixed(2)) 
          : Number(sData.amount || 0);
        let updatedCostPerUnit = updatedVolume > 0 ? Number((updatedCost / updatedVolume).toFixed(2)) : 0;

        const updateData = {
          totalVolume: Number(updatedVolume.toFixed(2)),
          totalCost: Number(updatedCost.toFixed(2)),
          amount: updatedPackage,
          CostPerUnit: updatedCostPerUnit,
        };
        if (updatedCostPerUnit > 0) {
          updateData.lastUnitCost = updatedCostPerUnit;
        }

        await updateDoc(stockRef, updateData);
      }
    }

    // 3. Atualizar despesa de descarte na coleção outgoing se existir
    try {
      if (targetStockId) {
        const outgoingRef = collection(db, 'outgoing');
        const q = query(outgoingRef, where('stockId', '==', targetStockId), where('category', '==', 'Descarte'));
        const querySnap = await getDocs(q);
        querySnap.forEach(async (dDoc) => {
          await updateDoc(doc(db, 'outgoing', dDoc.id), {
            value: Number(newDiscardCost.toFixed(2)),
            confirmation: Number(newDiscardCost.toFixed(2)),
            obs: newNote,
          });
        });
      }
    } catch (e) {
      console.warn('Aviso ao atualizar despesa de descarte:', e);
    }

    return true;
  } catch (err) {
    console.error('Erro ao atualizar log de descarte:', err);
    return false;
  }
}

/**
 * Remove um log de entrada de estoque e estorna os valores do item no estoque.
 */
export async function deleteStockLogEntry(logId, stockId) {
  try {
    const { doc, getDoc, updateDoc, deleteDoc } = await import('firebase/firestore');
    const { db } = await import('../config-firebase/firebase.js');

    const logRef = doc(db, 'stockUsageLogs', logId);
    const logSnap = await getDoc(logRef);
    if (!logSnap.exists()) return false;

    const oldData = logSnap.data();
    const oldVolume = Number(oldData.inputProduct || oldData.entrada || 0);
    const oldCost = Number(oldData.cost || 0);

    // Buscar volumePerUnit do estoque para converter o volume antigo em quantidade de pacotes caso entryAmount não esteja disponível
    let volPerUnit = 1;
    if (oldData.entryAmount === undefined && stockId) {
      const stockRef = doc(db, 'stock', stockId);
      const stockSnap = await getDoc(stockRef);
      if (stockSnap.exists()) {
        const sData = stockSnap.data();
        volPerUnit = Number(sData.volumePerUnit) > 0 ? Number(sData.volumePerUnit) : 1;
      }
    }
    const oldEntryPackage = oldData.entryAmount !== undefined ? Number(oldData.entryAmount) : (volPerUnit > 0 ? Math.round(oldVolume / volPerUnit) : 1);

    await deleteDoc(logRef);

    if (stockId) {
      const stockRef = doc(db, 'stock', stockId);
      const stockSnap = await getDoc(stockRef);
      if (stockSnap.exists()) {
        const sData = stockSnap.data();
        let updatedVolume = Math.max(0, Number(sData.totalVolume || 0) - oldVolume);
        let updatedCost = Math.max(0, Number(sData.totalCost || 0) - oldCost);
        let updatedPackage = Math.max(0, Number(sData.amount || 0) - oldEntryPackage);
        let updatedCostPerUnit = updatedVolume > 0 ? Number((updatedCost / updatedVolume).toFixed(2)) : 0;

        const updateData = {
          totalVolume: updatedVolume,
          totalCost: updatedCost,
          amount: updatedPackage,
          CostPerUnit: updatedCostPerUnit,
        };
        if (updatedCostPerUnit > 0) {
          updateData.lastUnitCost = updatedCostPerUnit;
        }

        await updateDoc(stockRef, updateData);
      }
    }
    return true;
  } catch (err) {
    console.error('Erro ao excluir log de estoque:', err);
    return false;
  }
}

/**
 * Registra a movimentação diária consolidada do estoque.
 * Essa função calcula o valor atualizado do estoque na hora em que é chamada
 * e insere um registro na coleção dailyStockSnapshot no documento correspondente a "hoje".
 * 
 * @param {string} agent - Agente da movimentação (Venda, Entrada de Mercadoria, Edição, Inventário, Perda, etc.)
 */
export async function registerDailyStockMovement(agent) {
  try {
    const stockCollection = collection(db, 'stock');
    const stockDocs = await getDocs(stockCollection);
    
    let totalStockValue = 0;
    stockDocs.forEach(docSnap => {
      const item = docSnap.data();
      if (item.operationSupplies === false && (item.activityStatus === undefined || item.activityStatus === false)) {
        totalStockValue += Number(item.totalCost) || 0;
      }
    });

    // Pega a data local no formato YYYY-MM-DD para usar como ID
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const dateStr = `${year}-${month}-${day}`;

    const docRef = doc(db, 'dailyStockSnapshot', dateStr);
    const docSnap = await getDoc(docRef);

    const movement = {
      value: totalStockValue,
      agent: agent,
      timestamp: Date.now()
    };

    if (!docSnap.exists()) {
      // Se não existir o doc do dia, insere primeiro um "Valor Inicial" (o valor atual antes dessa alteração específica não temos exatamente, 
      // mas se não existia o documento, podemos assumir que o "Valor Inicial" é igual ao primeiro cálculo, ou apenas começar com o agent)
      // Como o usuário pediu "Valor Inicial", vamos colocar um de Valor Inicial e o da ação atual.
      await setDoc(docRef, {
        date: dateStr,
        timestamp: Date.now(),
        totalStockValue: totalStockValue,
        movements: [
          { value: totalStockValue, agent: 'Valor Inicial', timestamp: Date.now() - 1000 },
          movement
        ]
      });
    } else {
      await updateDoc(docRef, {
        totalStockValue: totalStockValue,
        movements: arrayUnion(movement)
      });
    }
    console.log(`[Snapshot] Movimentação salva com sucesso! Agente: ${agent}, Valor: R$${totalStockValue}`);
  } catch (err) {
    console.error('Erro ao registrar movimentação de estoque:', err);
  }
}
